/**
 * Maps route pathnames to page keys for fallback timestamp lookup.
 * Used when a page does not provide explicit PAGE_LAST_UPDATED config.
 */
export const ROUTE_TO_PAGE_KEY = {
  '/': 'HomePage',
  '/bio': 'BioPage',
  '/bio/sport': 'SportPage',
  '/research': 'ResearchPage',
  '/research/phd': 'PhdPage',
  '/research/phd/presentation': 'PhdPresentationPage',
  '/research/phd/dissertation': 'PhdDissertationPage',
  '/research/phd/map': 'PhdMapPage',
  '/research/latex_in_matlab_ticks': 'LatexInMatlabTicksPage',
  '/research/advanced_matlab_boxplot': 'AdvancedMatlabBoxplotPage',
  '/projects': 'ProjectsPage',
  '/projects/inetanalytics': 'InetAnalyticsPage',
  '/projects/inetanalytics/planetlab': 'PlanetLabPage',
  '/projects/inetanalytics/mercury': 'MercuryPage',
  '/projects/ytcrawler/release1': 'YtCrawlerRelease1Page',
  '/projects/ytcrawler/release2': 'YtCrawlerRelease2Page',
  '/projects/ytanalytics': 'YtAnalyticsPage',
  '/projects/simworker': 'SimWorkerPage',
  '/projects/simstream': 'SimStreamPage',
  '/publications': 'PublicationsPage',
  '/teaching': 'TeachingPage',
  '/events': 'EventsPage',
};
